import { render, staticRenderFns } from "./kanbanboard.vue.html?vue&type=template&id=8911df82&scoped=true"
import script from "./kanbanboard.controller?vue&type=script&lang=js&external"
export * from "./kanbanboard.controller?vue&type=script&lang=js&external"
import style0 from "./kanbanboard.vue.html?vue&type=style&index=0&id=8911df82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8911df82",
  null
  
)

export default component.exports